import lodash from "lodash";
import moment from "moment";
import { filter } from "../../../../utils/search";
import Base, { criteriaIgnore } from "../base.store";

const baseUrl = "/api/v1/security/users";
const base = new Base(baseUrl);

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {}),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        changePassword(context, { data, config }) {
            return base.request.put(`${baseUrl}/change-password`, data, { ...config });
        },
        meProfile(context, { config }) {
            return base.request.get(`${baseUrl}/me/profile`, { ...config });
        },
        meProfileUpdate(context, { data, config }) {
            return base.request.put(`${baseUrl}/me/profile`, data, { ...config });
        },
        meChangePassword(context, { data, config }) {
            return base.request.put(`${baseUrl}/me/change-password`, data, { ...config });
        },
        register(context, { data, config }) {
            return base.request.post(`${baseUrl}/register`, data, { ...config });
        },
        registerOfficer(context, { data, config }) {
            return base.request.post(`${baseUrl}/register-officer`, data, { ...config });
        },
        hasUsername(context, { username, isCheckDraft, idIgnore, config }) {
            return base.request.post(`${baseUrl}/has-username`, { username, isCheckDraft, idIgnore }, { ...config });
        },
        hasIdCard(context, { cardKey, idCard, idIgnore, config }) {
            return base.request.post(`${baseUrl}/has-id-card`, { refDocumentTypePerson: { key: cardKey }, idCard, id: idIgnore }, { ...config });
        },
        hasIdCardActive(context, { cardKey, idCard, idIgnore, config }) {
            return base.request.post(`${baseUrl}/has-id-card`, { refDocumentTypePerson: { key: cardKey }, idCard, id: idIgnore, isActive: true }, { ...config });
        },
        checkIdTax(context, { idTax, config }) {
            return base.request.post(`${baseUrl}/check-id-tax`, { idTax }, { ...config }).then(data => {
                data?.ResultList?.forEach(d => {
                    if (d.JuristicName_TH) {
                        d.JuristicName_TH = d.JuristicName_TH.replaceAll("  ", " ").replaceAll("  ", " ");
                    }
                    if (d.JuristicName_EN) {
                        d.JuristicName_EN = d.JuristicName_EN.replaceAll("  ", " ").replaceAll("  ", " ");
                    }
                });
                return data;
            });
        },
        checkIdCard(context, { idCard, config }) {
            return base.request.post(`${baseUrl}/check-id-card`, { idCard }, { ...config });
        },
        saveEmployee(context, { data, config }) {
            return base.request.put(`${baseUrl}/employee`, data, { ...config });
        },
        saveCa(context, { data, config }) {
            return base.request.put(`${baseUrl}/ca`, data, { ...config });
        },
        customsSave(context, { data, config }) {
            return base.request.put(`${baseUrl}/customs`, data, { ...config });
        },
        customsSearch(context, { criteria, config }) {
            criteria = lodash.cloneDeepWith(criteria, (value, key) => {
                if (criteriaIgnore.includes(key)) {
                    return null;
                }
            });
            return base.request.post(`${baseUrl}/customs/_search`, criteria, { ...config });
        },
        updateStatus(context, { data, config }) {
            return base.request.put(`${baseUrl}/status`, data, { ...config });
        },
        cacheFindAll(context, { searchQuery }) {
            let force = false;
            const cacheDateResult = context.state.cacheDate.list;
            if (cacheDateResult && cacheDateResult.isBefore(moment())) {
                force = true;
            }
            const where = [{ name: "fullName", operator: "like", value: searchQuery }];
            const sort = [{ name: "fullName", type: "asc" }];
            const list = context.state.list || [];
            if (list.length > 0 && !force) {
                return filter({ list, where, sort });
            }
            return context
                .dispatch("findAll", { criteria: { select: ["id", "fullName", "refTitle.value", "refImage.url"] } })
                .then(list => filter({ list, where, sort }));
        }
    },
    mutations: {
        ...base.mutations
    }
};
